module.exports = __webpack_public_path__ + "media/images/reportimages/educational_impact-7ada4ffac33ad9df9ccef0b131dedb74.png";